export default "__VITE_ASSET__pjv2zOj___"